module.exports = __webpack_public_path__ + "static/media/page-0.5b001ad1.png";